var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightlyActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61616 8.71233L10.8212 6.38373C11.173 6.12735 11.6077 5.98543 12.064 6.0008C13.1754 6.02813 14.1514 6.75668 14.4909 7.82036C14.6772 8.40431 14.8471 8.79836 15.0007 9.0025C15.913 10.2155 17.3645 11 18.9992 11V13C16.8245 13 14.8815 12.0083 13.5976 10.4526L12.9 14.4085L14.9611 16.138L17.1843 22.246L15.3049 22.93L13.265 17.3256L9.87479 14.4808C9.32724 14.0382 9.03042 13.3192 9.16134 12.5767L9.66994 9.6923L8.9931 10.1841L6.86609 13.1116L5.24805 11.9361L7.59919 8.7L7.61616 8.71233ZM13.4992 5.5C12.3946 5.5 11.4992 4.60457 11.4992 3.5C11.4992 2.39543 12.3946 1.5 13.4992 1.5C14.6037 1.5 15.4992 2.39543 15.4992 3.5C15.4992 4.60457 14.6037 5.5 13.4992 5.5ZM10.5276 18.6813L7.31368 22.5116L5.7816 21.226L8.75677 17.6803L9.50329 15.5L11.2944 17L10.5276 18.6813Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightlyActive);
export default __webpack_public_path__ + "static/media/lightly-active.379459730728b67e757369ee65a752f6.svg";
export { ForwardRef as ReactComponent };